export default "__VITE_ASSET__DLXb9px9__"